export default __webpack_public_path__ + "static/media/7210-loading.a5f5308a.gif";